import React, {Component, Suspense} from 'react';
import {withRouter} from 'react-router-dom';
import {FullScreenLoading} from "../../../components/loading";
import ToolsHeader from '../components/header';
import {ToolsBody, ToolsContainer, ToolsWrapper} from '../style';
import ResponsiveFix from "../../../components/responsiveFix";

class Fullpage extends Component {
	render() {
		const {Component, route} = this.props;

		return (
			<ResponsiveFix>
				<ToolsHeader back={false} borderless noBack/>
				<ToolsWrapper>
					<ToolsBody noSidebar>
						<ToolsContainer>
							<Suspense fallback={<FullScreenLoading/>}>
								<Component route={route}/>
							</Suspense>
						</ToolsContainer>
					</ToolsBody>
				</ToolsWrapper>
			</ResponsiveFix>
		)
	}
}

export default withRouter(Fullpage);